const menus = [
    {
        id: 1,
        name: 'Home',
        links: '/',
    },
    {
        id: 5,
        name: 'Games',
        namesub: [
            {
                id: 1,
                sub: 'SmithyDao',
                links: '/smithydao'
            },
            {
                id: 2,
                sub: 'Beratone',
                links: '/beratone'
            },
            {
                id: 3,
                sub: 'Beramonium',
                links: '/beramonium'
            },
            {
                id: 4,
                sub: 'Goldinc',
                links: '/goldinc'
            },
            {
                id: 6,
                sub: 'smolage',
                links: '/smolage'
            },
        ],
    },
    {
        id: 6,
        name: 'Contact',
        links: '/contact'
    },
    
]

export default menus;